<template>
  <v-dialog v-model="show" persistent max-width="400" v-if="providersObj">
    <v-card>
      <v-card-title class="justify-end px-3 py-3">
        <p class="font--m-4 mt-1 mb-0 ml-3">
          인증하기 버튼을 누르시면 <br />
          고객님께 인증번호가 발송됩니다.
        </p>
        <v-spacer></v-spacer>
        <a class="mt-0 mb-5" @click="closeDialog()" id="btn__SZk/m6ERnUKwpwTTr/El9g==">
          <v-icon large>mdi-close</v-icon>
        </a>
      </v-card-title>
      <v-card-text class="pa-5 mb-0" v-if="providersObj[mall.provider]">
        <v-row no-gutters class="mb-10">
          <v-col cols="12" class="text-center mb-5">
            <div class="mall">
              <v-avatar size="50">
                <img
                  :src="
                    providersObj[mall.provider].logo
                      ? providersObj[mall.provider].logo
                      : providersObj[mall.provider].logo404Path
                  "
                  @error="$event.target.src = providersObj[mall.provider].logo404Path"
                />
              </v-avatar>
              <span class="font--m-4 ml-5">{{ providersObj[mall.provider].name }}</span>
            </div>
            <div class="mall-button mt-1">
              <BasicButton
                id="btn__3GON5TLI1kS2zUVcxg+8sg=="
                width="90px"
                height="40px"
                class="font--m-6"
                :disabled="isLoading || isExpireTimeOut"
                @click="inquire"
                :loading="isLoading"
                >인증번호받기</BasicButton
              >
            </div>
          </v-col>
          <template>
            <v-col cols="12" align="center" justify="center">
              <v-col cols="12">
                <v-text-field
                  outlined
                  placeholder="인증번호 입력"
                  dense
                  class="mb-2"
                  hide-details
                  ref="otp"
                  v-model="otp"
                  v-input-restrict.number
                >
                  <template v-slot:append>
                    <v-fade-transition leave-absolute>
                      <ExpireTime
                        class="mt-1"
                        v-if="resetTimeoutDate"
                        :expire-date="resetTimeoutDate"
                        @emitTimeOver="isTimeOut"
                      ></ExpireTime>
                    </v-fade-transition>
                  </template>
                </v-text-field>
              </v-col>
            </v-col>
            <v-col cols="12" class="text-center">
              <BasicButton
                id="btn__Ai3bfknCE0qpHh/5UqYiUw=="
                width="90px"
                height="40px"
                class="font--m-6"
                :loading="isConfirmLoading"
                :disabled="isConfirmLoading || !resetTimeoutDate"
                @click="confirm(mallLimit, otp)"
                >확인</BasicButton
              >
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ExpireTime from '@/components/mall/ExpireTime.vue'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  props: {
    mallLimit: {
      type: Object,
    },
  },
  components: {
    ExpireTime,
  },
  data() {
    return {
      show: true,
      isExpireTimeOut: false,
      resetTimeoutDate: null,
      otp: null,
      isLoading: false,
      isConfirmLoading: false,
      mall: {
        uuid: null,
        provider: null,
        adminId: null,
        adminPassword: null,
      },
      mallLimits: null,
    }
  },
  watch: {
    resetTimeoutDate(v) {
      if (v) {
        this.isExpireTimeOut = true
      } else {
        this.isExpireTimeOut = false
      }
    },
  },
  computed: {
    ...mapGetters('mall', ['providersObj']),
    ...mapState('bnpl', ['availableAmount', 'wrongCredentials', 'is2faRequireds']),
  },
  async created() {
    this.mallLimits = await this.getMallLimitsDetail({
      uuid: this.mallLimit.uuid,
    })
    this.mall = this.mallLimits.mall
  },
  methods: {
    ...mapActions('mall', ['getMallProviders']),
    ...mapActions('bnpl', ['getAvailableAmount']),
    ...mapActions('mallLimits', [
      'getMallLimitsDetail',
      'getTwoFactorAuthCode',
      'confirmTwoFactorAuthCode',
    ]),
    closeDialog() {
      this.show = false
      this.$emit('emitClose', false)
    },
    async isTimeOut() {
      await this.$swal.basic.alert({
        html: `[${
          this.providersObj[this.mall.provider].name
        }] "인증번호"가 입력되지 않았습니다. <br />조회를 다시 해주세요.`,
      })
      this.resetTimeoutDate = null
      this.closeDialog()
    },
    async inquire() {
      this.isLoading = true
      try {
        const data = await this.getTwoFactorAuthCode({
          uuid: this.mallLimit.uuid,
        })
        this.resetTimeoutDate = new Date()
        this.resetTimeoutDate.setSeconds(this.resetTimeoutDate.getSeconds() + data.remainTime)
        this.$nextTick(() => {
          this.$refs.otp.focus()
        })
      } catch (e) {
        if (e.status === 500) {
          this.$swal.basic.alert('인증요청에 실패하였습니다. 잠시 후 다시 시도해주세요.')
          return
        }
        throw e
      } finally {
        this.isLoading = false
      }
    },
    async confirm(mallLimit, otp) {
      this.isConfirmLoading = true
      try {
        const { succeededTwoFactorAuth } = await this.confirmTwoFactorAuthCode({
          mallLimit,
          otp,
        })
        if (succeededTwoFactorAuth !== true) {
          await this.$swal.basic.alert({
            html: `[${
              this.providersObj[this.mall.provider].name
            }] "인증번호"가 일치하지 않습니다. <br />조회를 다시 해주세요.`,
          })
          this.closeDialog()
          return
        }
        await this.getAvailableAmount()
        this.$emit('emitResult', true)
        this.closeDialog()
      } catch (e) {
        if (e.status === 500 && e.data?.detail) {
          this.$swal.basic.alert(e.data.detail)
          return
        }
        throw e
      } finally {
        this.isConfirmLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mall {
  float: left;
}
.mall-button {
  float: right;
}
.v-btn {
  border-radius: 24px !important;
}
</style>
